<template>
  <div class="about t-al-l" style="background-color: #ffffff;min-height: 100%;">
    <van-collapse v-model="activeNames">
      <van-collapse-item :title="item.tit" :name="item.id" v-for="(item, index) in list">
        <div v-html="item.txt"></div>
      </van-collapse-item>
    </van-collapse>

    <div style="height: 60px;">

    </div>
  </div>
</template>

<script>
import common from '../assets/js/common'
import addone from '../components/addone'
import stroe from '../store'

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components:
      {
        addone
      },
  data: function(){
    return {
      roleCn:'',
      phone:'',
      list: [],
      activeNames: []
    }
  },
  methods:{
    initPage:function()
    {
      common.cusHttp(this,'/boot/question.php').then((res)=>{
        // console.log(res.data);
        res = JSON.parse(res.data)
        this.list = res.data.data
      })
    },
    resetPassword:function()
    {
    }
  },
  created:function()
  {
  },
  mounted()
  {
    // alert('ִ��')
    // this.$emit('committarbar',2)
    this.initPage();
  },
  onShow()
  {
  },
  computed:{
  }
}
</script>

<style scoped>
.fs-14-fc-ffffff
{
  color: #ffffff;;
  font-size: 0.4375rem;
  font-family: PingFangSC-Medium;
  line-height: 0.525rem;
}
</style>
